"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compile = compile;
const CompiledExpression_1 = require("../expression/CompiledExpression");
/**
 * Compiles a formula expression string into a CompiledExpression object.
 * @param {string} expression - The formula expression to compile
 * @returns {CompiledExpression} A compiled expression that can be evaluated
 * @example
 * const expr = compile("age+3");
 * const result = expr.evaluate({age:18});
 */
function compile(expression) {
    return new CompiledExpression_1.CompiledFormulaExpression(expression);
}
